import { render } from "./ContentComponent.vue?vue&type=template&id=1451a91d"
import script from "./ContentComponent.vue?vue&type=script&lang=js"
export * from "./ContentComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/FAQManagement/components/ContentComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1451a91d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1451a91d', __exports__)) {
    api.reload('1451a91d', __exports__)
  }
  
  module.hot.accept("./ContentComponent.vue?vue&type=template&id=1451a91d", () => {
    api.rerender('1451a91d', render)
  })

}


export default __exports__